export default __webpack_public_path__ + "static/media/security.9dd326df.png";